import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {Menu, X, Plane} from 'lucide-react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-[#0A2540] text-white sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2 font-bold text-xl hover:text-[#FF6B35] transition-colors">
            <Plane className="w-6 h-6" />
            <span>JE Inform</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/destinations" className="hover:text-[#FF6B35] transition-colors">Destinations</Link>
            <Link to="/attractions" className="hover:text-[#FF6B35] transition-colors">Attractions</Link>
            <Link to="/tools" className="hover:text-[#FF6B35] transition-colors">Tools</Link>
            <Link to="/guides" className="hover:text-[#FF6B35] transition-colors">Guides</Link>
            <Link to="/deals" className="hover:text-[#FF6B35] transition-colors">Deals</Link>
            <Link to="/about" className="hover:text-[#FF6B35] transition-colors">About</Link>
            <Link to="/contact" className="bg-[#FF6B35] px-4 py-2 rounded-lg hover:bg-[#E55A2B] transition-colors">Contact</Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#0A2540] border-t border-gray-700">
          <div className="px-4 py-4 space-y-3">
            <Link to="/destinations" className="block hover:text-[#FF6B35] transition-colors">Destinations</Link>
            <Link to="/attractions" className="block hover:text-[#FF6B35] transition-colors">Attractions</Link>
            <Link to="/tools" className="block hover:text-[#FF6B35] transition-colors">Tools</Link>
            <Link to="/guides" className="block hover:text-[#FF6B35] transition-colors">Guides</Link>
            <Link to="/deals" className="block hover:text-[#FF6B35] transition-colors">Deals</Link>
            <Link to="/about" className="block hover:text-[#FF6B35] transition-colors">About</Link>
            <Link to="/contact" className="block bg-[#FF6B35] px-4 py-2 rounded-lg hover:bg-[#E55A2B] transition-colors text-center">Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
